import React from 'react'

import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type ArtisanTopDescriptionProps = {
  descriptionLines: string[]
  isRight?: boolean
  isForcedBreak?: boolean
}

const ArtisanTopDescription: React.FC<ArtisanTopDescriptionProps> = ({
  descriptionLines,
  isRight = false,
  isForcedBreak = false,
}) => {
  const { locale } = useTranslation()
  return (
    <div
      className={style.description}
      data-right={isRight}
      data-en={locale === 'en'}
    >
      {descriptionLines.map((descriptionLine, index) => (
        <span key={descriptionLine}>
          {index !== 0 && (
            <br className={style.brTab} data-break={isForcedBreak} />
          )}
          {descriptionLine}
        </span>
      ))}
    </div>
  )
}

export default ArtisanTopDescription
